import { $journalApi } from "@/entities/journal/fetch/fetch-client";

export const usePostSignEntryPartTwo = () =>
  $journalApi.useMutation(
    "post",
    "/api/v1/journals/section-four/{sectionFourListId}/items/{itemNoVersionId}/itemPartTwo/{itemPartTwoId}/sign/done",
  );

